<template>
  <d-modal
    v-if="showModal"
    @close="closeModal"
    class="crm-new-popup"
    style="background-color: rgba(0,0,0,0.6)!important;">
    <d-modal-header>
      <d-modal-title>
        <h3 class="page-title">
          <template v-if="isEdit">Edycja placówki</template>
          <template v-else>Dodaj placówkę</template>
        </h3>
      </d-modal-title>
    </d-modal-header>
    <d-modal-body>
      <validation-observer
        ref="customers-form-institutions"
        tag="form">
        <div class="form-group">
          <label for="name">
            Nazwa:
          </label>
          <validation-provider
            rules="required"
            name="name"
            v-slot="{ errors }">
            <d-input
              :state="errors.length ? 'invalid' : null"
              type="text"
              v-model="data.name" />
            <div class="invalid-feedback">
              {{ errors[0] }}
            </div>
          </validation-provider>
        </div>
        <div class="form-group">
          <label for="contact_person">
            Imię i nazwisko osoby kontaktowej:
          </label>
          <validation-provider
            rules="required"
            name="contact_person"
            v-slot="{ errors }">
            <d-input
              :state="errors.length ? 'invalid' : null"
              type="text"
              v-model="data.contact_person" />
            <div class="invalid-feedback">
              {{ errors[0] }}
            </div>
          </validation-provider>
        </div>
        <d-row>
          <d-col
            cols="6"
            md="6"
            lg="6">
            <div class="form-group">
              <label for="phone">
                Telefon:
              </label>
              <validation-provider
                rules="required|only-numbers|min:9|max:9"
                name="phone"
                v-slot="{ errors }">
                <d-input
                  :state="errors.length ? 'invalid' : null"
                  type="text"
                  v-model="data.phone" />
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </validation-provider>
            </div>
          </d-col>
          <d-col
            cols="6"
            md="6"
            lg="6">
            <div class="form-group">
              <label for="email">
                Adres e-mail:
              </label>
              <validation-provider
                rules="required|email"
                name="email"
                v-slot="{ errors }">
                <d-input
                  :state="errors.length ? 'invalid' : null"
                  type="email"
                  v-model="data.email" />
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </validation-provider>
            </div>
          </d-col>
        </d-row>
        <div class="form-group">
          <label for="city">
            Miasto:
          </label>
          <validation-provider
            rules="required"
            name="city"
            v-slot="{ errors }">
            <d-input
              :state="errors.length ? 'invalid' : null"
              type="text"
              v-model="data.city" />
            <div class="invalid-feedback">
              {{ errors[0] }}
            </div>
          </validation-provider>
        </div>
        <d-row>
          <d-col
            cols="6"
            md="6"
            lg="8">
            <div class="form-group">
              <label for="address">
                Ulica i numer:
              </label>
              <validation-provider
                rules="required"
                name="address"
                v-slot="{ errors }">
                <d-input
                  :state="errors.length ? 'invalid' : null"
                  type="text"
                  v-model="data.address" />
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </validation-provider>
            </div>
          </d-col>
          <d-col
            cols="6"
            md="6"
            lg="4">
            <div class="form-group">
              <label for="post_code">
                Kod pocztowy:
              </label>
              <validation-provider
                rules="required"
                name="post_code"
                v-slot="{ errors }">
                <d-input
                  :state="errors.length ? 'invalid' : null"
                  type="text"
                  v-model="data.post_code" />
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </validation-provider>
            </div>
          </d-col>
        </d-row>
        <d-row>
          <d-col cols="12">
            <div class="form-group">
              <label for="containers_number">
                Ilość pojemników do zwrotu:
              </label>
              <validation-provider
                rules="integer"
                name="containers_number"
                v-slot="{ errors }">
                <d-input
                  :state="errors.length ? 'invalid' : null"
                  type="number"
                  v-model="data.containers_number" />
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </validation-provider>
            </div>
          </d-col>
        </d-row>

        <d-row
          v-if="data.containers && data.containers.length"
          class="mb-4">
          <d-col cols="12">
            <d-button
              v-d-toggle.historyAccordion
              @click.prevent="showHistory = !showHistory"
              class="w-100"
              theme="info"
              outline
              size="sm">
              <i class="material-icons">
                {{ showHistory ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
              </i>
              {{ showHistory ? 'Schowaj historię' : 'Pokaż historię' }}
            </d-button>
            <d-collapse
              id="historyAccordion"
              accordion="historyAccordion">
              <div class="pt-3">
                <institution-containers-history
                  class="pt-3"
                  :containers-history="data.containers" />
              </div>
            </d-collapse>
          </d-col>
        </d-row>
        <div class="form-group">
          <d-checkbox
            inline
            v-model="data.individual_invoice_new">
            Posiada swoje dane do faktury
          </d-checkbox>
        </div>
        <div
          class="form-control mb-3"
          v-if="data.individual_invoice_new === true">
          <div class="form-group">
            <label for="invoice_name">
              Nazwa:
            </label>
            <validation-provider
              rules="required"
              name="invoice_name"
              v-slot="{ errors }">
              <d-input
                :state="errors.length ? 'invalid' : null"
                type="text"
                v-model="data.invoice_name" />
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>
          <div class="form-group">
            <label for="invoice_nip">
              NIP:
            </label>
            <validation-provider
              name="invoice_nip"
              rules="nip"
              v-slot="{ errors }">
              <d-input
                :state="errors.length ? 'invalid' : null"
                type="text"
                v-model="data.invoice_nip" />
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>
          <div class="form-group">
            <label for="invoice_city">
              Miasto:
            </label>
            <validation-provider
              rules="required"
              name="invoice_city"
              v-slot="{ errors }">
              <d-input
                :state="errors.length ? 'invalid' : null"
                type="text"
                v-model="data.invoice_city" />
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>
          <d-row>
            <d-col
              cols="6"
              md="6"
              lg="8">
              <div class="form-group">
                <label for="invoice_address">
                  Ulica i numer:
                </label>
                <validation-provider
                  rules="required"
                  name="invoice_address"
                  v-slot="{ errors }">
                  <d-input
                    :state="errors.length ? 'invalid' : null"
                    type="text"
                    v-model="data.invoice_address" />
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>
            </d-col>
            <d-col
              cols="6"
              md="6"
              lg="4">
              <div class="form-group">
                <label for="invoice_post_code">
                  Kod pocztowy:
                </label>
                <validation-provider
                  rules="required"
                  name="invoice_post_code"
                  v-slot="{ errors }">
                  <d-input
                    :state="errors.length ? 'invalid' : null"
                    type="text"
                    v-model="data.invoice_post_code" />
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>
            </d-col>
          </d-row>
          <div class="form-group">
            <validation-provider
              :rules="'required'"
              :name="'settlement_method'"
              v-slot="{ errors }">
              <label
                class="title-box"
                :for="data.settlement_method">
                Metoda płatności:
              </label>
              <div :class="{ 'form-control': true, 'is-select': true, 'is-invalid': errors.length }">
                <v-select
                  :options="paymentMethods"
                  v-model="data.settlement_method"
                  :reduce="method => method.id"
                  placeholder="Wybierz metodę"
                  label="id"
                  :state="errors.length ? 'invalid' : null">
                  <template
                    slot="option"
                    slot-scope="option">
                    <div class="d-center">
                      {{ option.name }}
                    </div>
                  </template>
                  <template
                    slot="selected-option"
                    slot-scope="option">
                    <div class="selected d-center">
                      {{ option.name }}
                    </div>
                  </template>
                </v-select>
              </div>
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>
          <div class="form-group">
            <label for="invoice_description">
              Dodatkowy opis na fakturze:
            </label>
            <validation-provider
              name="invoice_description"
              v-slot="{ errors }">
              <textarea
                class="form-control"
                :state="errors.length ? 'invalid' : null"
                type="text"
                v-model="data.invoice_description"></textarea>
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>
          <div class="form-group">
            <label for="invoice_frequency">
              Częstotliwość wystawiania faktur:
            </label>
            <validation-provider
              name="invoice_frequency"
              :rules="data.invoice_settlementNew ? 'required' : ''"
              v-slot="{ errors }">
              <div :class="{ 'form-control': true, 'is-select': true, 'is-invalid': errors.length }">
                <v-select
                  :options="[{value: 'WEEKLY', text: 'Raz w tygodniu'},{value: 'MONTHLY', text: 'Raz w miesiąc'}]"
                  :reduce="type => type.value"
                  v-model="data.invoice_frequency"
                  placeholder="Wybierz częstotliwość"
                  label="text"
                  :state="errors.length ? 'invalid' : null">
                </v-select>
              </div>
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>
        </div>
        <div class="form-group">
          <d-checkbox
            inline
            v-model="data.individual_prices_new">
            Posiada swój cennik
          </d-checkbox>
        </div>
        <div class="popup-box-buttons">
          <d-button
            theme="success"
            class="text-nowrap"
            @click.prevent="validateForm">
            Potwierdź
          </d-button>
          <d-button
            theme="secondary"
            class="text-nowrap ml-3"
            @click.prevent="closeModal">
            Anuluj
          </d-button>
        </div>
      </validation-observer>
      <div
        v-if="edit && !institution.id"
        class="pb-3 pt-3 text-center">
        Trwa ładowanie danych&hellip;
      </div>
    </d-modal-body>
  </d-modal>
</template>

<script>
import FormUtils from '../../../utils/FormUtils.js';
import PaymentMethods from '@/data/payments-methods.js';
import InstitutionContainersHistory from './InstitutionContainersHistory.vue';

export default {
  name: 'customers-form-institutions',
  components: {
    InstitutionContainersHistory
  },
  data () {
    return {
      data: {
        address: '',
        city: '',
        contact_person: '',
        containers: [],
        containers_number: 0,
        customer_id: '0',
        email: '',
        id: '0',
        individual_invoice: 0,
        individual_invoice_new: false,
        individual_prices: 0,
        individual_prices_new: false,
        invoice_address: '',
        invoice_city: '',
        invoice_description: '',
        invoice_frequency: 'WEEKLY',
        invoice_name: '',
        invoice_nip: '',
        invoice_post_code: '',
        invoice_settlement: 0,
        invoice_settlement_new: false,
        name: '',
        phone: '',
        post_code: '',
        settlement_method: null
      },
      showHistory: false,
      loaded_auth: false,
      payment_methods_required: false,
      institution: []
    };
  },
  props: {
    showModal: {
      type: Boolean,
      required: true
    },
    closeModal: {
      type: Function,
      required: true
    },
    refresh: {
      type: Function,
      required: true
    },
    customerData: {
      type: [Object, Array],
      required: true
    },
    edit: {
      type: [String, Number]
    },
    addId: {
      type: [String, Number],
      required: true
    },
  },
  watch: {
    edit () {
      if (this.isEdit !== '') {
        if (this.institution.length) {
          this.objectData();
        }
      } else {
        this.loaded = true;
      }
    },
    addId () {
      setTimeout(() => {
        this.objectDataAdd();
      }, 800);
    },
    'data.invoice_settlement': function (value) {
      this.data.invoice_settlementNew = value === 1;
    },
  },
  mounted () {
    if (this.isAdd) {
      setTimeout(() => {
        this.objectDataAdd();
      }, 800);
    }
    if (this.isEdit) {
      this.getAuthorization();
    }
  },
  computed: {
    paymentMethods () {
      return PaymentMethods;
    },
    allDataLoaded () {
      return this.loaded && this.loaded_auth;
    },
    isEdit () {
      return !!this.edit;
    },
    isAdd () {
      return !!this.addId;
    }
  },
  methods: {
    objectData () {
      this.data.id = this.institution.id;
      this.data.customer_id = this.institution.customer_id;
      this.data.containers = this.institution.containers;
      this.data.containers_number = this.institution.containers_number;
      this.data.name = this.institution.name;
      this.data.address = this.institution.address;
      this.data.post_code = this.institution.post_code;
      this.data.city = this.institution.city;
      this.data.contact_person = this.institution.contact_person;
      this.data.email = this.institution.email;
      this.data.phone = this.institution.phone;
      this.data.individual_prices_new = this.institution.individual_prices === 1;
      this.data.individual_invoice_new = this.institution.individual_invoice === 1;
      this.data.invoice_settlement_new = this.institution.invoice_settlement === 1;
      this.data.invoice_nip = this.institution.invoice_nip;
      this.data.invoice_name = this.institution.invoice_name;
      this.data.invoice_address = this.institution.invoice_address;
      this.data.invoice_post_code = this.institution.invoice_post_code;
      this.data.invoice_city = this.institution.invoice_city;
      this.data.settlement_method = this.institution.settlement_method;
      this.data.invoice_description = this.institution.invoice_description;
      this.data.invoice_frequency = this.institution.invoice_frequency ? this.institution.invoice_frequency : 'WEEKLY';
    },
    objectDataAdd () {
      this.data.customer_id = this.addId;
    },
    getAuthorization () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/customers/shops/item/' + this.edit,
        outputKey: 'institution',
        params: {
          pagination: false
        },
        successAction: () => {
          this.objectData();
        }
      });
    },
    clearData () {
      this.data = {
        id: '',
        address: '',
        city: '',
        contact_person: '',
        containers: [],
        containers_number: 0,
        customer_id: '',
        email: '',
        individual_invoice: '',
        individual_prices: '',
        invoice_address: '',
        invoice_city: '',
        invoice_description: '',
        invoice_frequency: '',
        invoice_name: '',
        invoice_nip: '',
        invoice_post_code: '',
        name: '',
        phone: '',
        post_code: '',
        settlement_method: ''
      };
      this.institution = [];
    },
    validateForm () {
      this.payment_methods_required = true;
      if (this.data.settlement_method !== '' || this.data.individual_invoice === 0) {
        FormUtils.validate(this.$refs['customers-form-institutions'], this.submitForm);
      }
    },
    submitForm  () {
      let formDataToSend = {
        id: this.data.id,
        customer_id: this.data.customer_id,
        containers_number: this.data.containers_number,
        name: this.data.name,
        address: this.data.address,
        post_code: this.data.post_code,
        city: this.data.city,
        contact_person: this.data.contact_person,
        invoice_settlement: this.data.invoice_settlementNew === true ? 1 : 0,
        email: this.data.email,
        phone: this.data.phone,
        individual_prices: this.data.individual_prices_new === true ? 1 : 0,
        individual_invoice: this.data.individual_invoice_new === true ? 1 : 0,
      };
      if (this.data.individual_invoice_new === false) {
        formDataToSend.invoice_nip = this.customerData.invoice_nip;
        formDataToSend.invoice_name = this.customerData.invoice_name;
        formDataToSend.invoice_address = this.customerData.invoice_address;
        formDataToSend.invoice_post_code = this.customerData.invoice_post_code;
        formDataToSend.invoice_city = this.customerData.invoice_city;
      } else {
        formDataToSend.invoice_nip = this.data.invoice_nip;
        formDataToSend.settlement_method = this.data.settlement_method;
        formDataToSend.invoice_name = this.data.invoice_name;
        formDataToSend.invoice_address = this.data.invoice_address;
        formDataToSend.invoice_post_code = this.data.invoice_post_code;
        formDataToSend.invoice_city = this.data.invoice_city;
        formDataToSend.invoice_description = this.data.invoice_description;
        formDataToSend.invoice_frequency = this.data.invoice_frequency;
      }
      let endpointUrl = this.isEdit ? '/customers/shops/update/' + this.edit : '/customers/shops/store';
      FormUtils.submit(this, {
        endpoint: endpointUrl,
        formData: formDataToSend,
        successTitle: 'Zapisano placówkę',
        successText: 'Wybrana placówka została zapisana',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Modyfikacja placówki nie powiodła się. Spróbuj ponownie.',
        successAction: () => {
          this.closeModal();
          this.refresh();
        }
      });
    }
  }
};
</script>

<style lang="scss">
@import '../../../assets/scss/crm-new-popup.scss';
</style>
